export enum enumProductTypes {
    Goot = 1,
    Muurplaat = 2,
    Frontpaneel_Cube = 3,
    Frontpaneel_Deluxe = 4,
    Staander = 5,
    Sierklik = 6,
    Middenligger = 7,
    Middenligger_versterkt = 8,
    Zijligger = 9,
    Middenligger_Deksel = 10,
    Zijligger_Deksel = 11,
    Goot_Zijkap_Classic = 12,
    Muurplaat_Zijkap = 13,
    F_profiel = 14,
    Ligger_Deksel = 15,
    Glazen_Schuifwand_railset_3_spoors = 16,
    Glazen_Schuifwand_railset_4_spoors = 17,
    Glazen_Schuifwand_railset_5_spoors = 18,
    Glazen_Schuifwand_railset_6_spoors = 19,
    Handvat = 20,
    Tochtstrip = 27,
    Frontglass = 28,
    Muurplaat_Rubber = 29,
    Bladvanger = 30,
    Schroef = 31,
    Polycarbonaat = 33,
    Led_Normaal = 34,
    Led_Dimbaar = 35,
    Zonwering = 36,
    Spie_Glas = 38,
    Spie_Polycarbonaat = 39,
    Glazen_Schuifwand = 40,
    Schuifpui = 41,
    Vast_Kozijn = 42,
    Aluminium_Rabat = 43,
    Geheel_Polycarbonaat = 44,
    RS_Screen = 45,
    Pergola = 46,
    Frontpaneel_Classic = 47,
    Led_Smart_Google = 48,
    Led_Smart_Somfy = 49,
    Led_Alleen_Gat = 115,
    Guillotine_Glassysteem = 50,
    Meenemer = 51,
    H_profiel_incl_wiel = 52,
    Helder_glas_10mm = 53,
    Getint_glas_10mm = 54,
    L_profiel = 55,
    H_profiel = 56,
    Koker_5x10_cm = 57,
    Funderingskoker_4x13_cm = 58,
    Statiekkoker = 59,
    Statiekkoker_Sierklik = 60,
    Aluminium_rabatdelen = 61,
    Sandwichpanelen = 62,
    U_profiel_sandwichpanelen = 63,
    Helder_glas_4_4_2 = 64,
    Opaal_glas_4_4_2 = 65,
    Getint_glas_4_4_2 = 66,
    Dubel_glas = 67,
    Modelglas = 68,
    Voetanker = 69,
    Gootverbindstuk = 70,
    Led_Dimbaar_Controller = 71,
    Glas_Profiel_Wiel = 72,
    Glas_Onder_Profiel = 73,
    Glas_Onder_Profiel_Zijkap = 74,
    Goot_Zijkap_Deluxe = 75,
    Goot_Zijkap_Cube = 76,
    Sileconenkit_Transparant = 95,
    Sileconenkit_Colored = 96,
    Statiek_Profiel_Deksel = 88,
    Stut_Afdekprofiel = 77,
    Stutprofiel = 78,
    Gootvoegprofiel = 79,
    Gootprofiel = 80,
    Glazen_Dragerprofiel = 81,
    Glazen_Dragerprofiel_Ligger = 89,
    Muurprofiel_Afdekking = 82,
    Muurprofiel = 83,
    Glazen_Drager_Strut_Joint_Profiel = 84,
    Glazen_Drager_Strut_Joint_Spacer_Profiel = 85,
    Dakgoot_En_Steunprofiel = 86,
    Goot_En_Wandafdekprofiel = 87,
    Motorkist_Profiel = 90,
    Motorkast_Afdekprofiel = 91,
    Railprofiel = 92,
    Front_Trekhaak_Profiel = 93,
    Front_Afdekprofiel = 94,
    Zonwering_Buis = 97,
    Zonwering_Accessorise_Set = 98,
    Schuttingpaal = 99,
    Schuttingpaneel_Recht = 100,
    Schuttingpaneel_Schuin = 101,
    Schuttingkoker_Profiel = 102,
    Schuttingdeur_Zijframepaal_Profiel = 103,
    Schuttingdeur_Zijframe_Profiel = 104,
    Schuttingkozijn_Onder_Boven_Profiel = 105,
    Schutting_Glaspaneel_Profiel = 106,
    Schuttingpaal_Afdek_Latprofiel = 107,
    Schuttingpaneel_Afdek_Profiel = 108,
    Schuttingdeur_Kozijn_Hoek_Profiel = 109,
    Elektriciteitskabel = 110,
    Schroeven_Klein_Ongelakt = 111,
    Schroeven_Klein_Gelakt = 112,
    Schroeven_Groot_6_Kant = 113,
    Koker_10x10_cm = 114,
    // BQB gaskets bought off a roll (meter-base stock, ADR-0009/0021)
    Bqb_Muurrubber = 124,
    Bqb_Drukrubber_2mm = 125,
    Bqb_Drager_Achterrubber = 126,
};
